import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2, SimpleChanges,
  ViewChild
} from '@angular/core';
import {Countries, PhoneRegex} from "../../../../../constants/general-variables";
import {
  FormControlErrorMessagesModule
} from "../../../../../pipes/form-control-error-messages/form-control-error-messages.module";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {UiHelperService} from "../../../../../services/helpers/ui-helper.service";
import {SpinnerComponent} from "../../../../../shared-components/spinner/spinner.component";
import {ProfileHttpService} from "../../../../../services/http-services/profile/profile-http.service";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'tl-edit-profile-phone',
  standalone: true,
  templateUrl: './edit-profile-phone.component.html',
  imports: [
    FormControlErrorMessagesModule,
    FormsModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    SpinnerComponent,
    NgClass,
    TranslateModule
  ]
})
export class EditProfilePhoneComponent implements OnInit, OnChanges {
  @Input() profileData: any;
  @Output() changeProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelChanges: EventEmitter<void> = new EventEmitter<void>();
  editProfilePhoneForm!: FormGroup;
  isSpinnerActive = false;
  formTriedToSubmit = false;
  isAreaCodeOpen =  false;
  selectedArea: any;
  @ViewChild('areaCodeBtn') areaCodeBtn: ElementRef | undefined;
  protected readonly Countries = Countries;

  constructor(private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private renderer: Renderer2,
              private uiHelperService: UiHelperService,
              private profileHttpService: ProfileHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.listenToClickAreaCode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileDate && changes.profileData.currentValue.phone_number) {
      const [areaCode, phone] = changes.profileData.currentValue.phone_number.split(' ');
      this.editProfilePhoneForm.controls.phone_number.patchValue(phone);
      this.selectedArea = this.Countries.find(country => {
        return country.phone_code === areaCode;
      });
    } else {
      this.selectedArea = this.Countries[0];
    }
  }

  listenToClickAreaCode(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.uiHelperService.checkIfClickedOutsideOfTheElement(this.areaCodeBtn, this.areaCodeBtn, e)) {
        this.isAreaCodeOpen = false;
      }
    });
  }
  buildForm(): void {
    this.editProfilePhoneForm = this.formBuilder.group({
      phone_number: ['', [Validators.required, Validators.pattern(PhoneRegex)]],
    });
    if (this.profileData.phone_number) {
      const [areaCode, phone] = this.profileData.phone_number.split(' ');
      this.editProfilePhoneForm.controls['phone_number'].patchValue(phone);
      this.selectedArea = this.Countries.find(country => {
        return country.phone_code === areaCode;
      })
    }
  }

  onSelectCodeArea(country: any): void {
    this.selectedArea = country;
    this.isAreaCodeOpen = false;
  }

  onCancelChanges(): void {
    this.editProfilePhoneForm.reset();
    if (this.profileData.phone_number) {
      const [areaCode, phone] = this.profileData.phone_number.split(' ');
      this.editProfilePhoneForm.controls['phone_number'].patchValue(phone);
      this.selectedArea = this.Countries.find(country => {
        return country.phone_code === areaCode;
      })
    }
    this.cancelChanges.emit();
  }

  onSubmitEditProfilePhoneForm(): void {
    this.formTriedToSubmit = true;
    if (this.editProfilePhoneForm.valid) {
      this.isSpinnerActive = true;
      this.profileHttpService.editAuthUserProfile({phone_number: this.selectedArea.phone_code + ' ' + this.editProfilePhoneForm.controls['phone_number'].value}).then((res: any) => {
        this.isSpinnerActive = false;
        this.changeProfile.emit(res.data);
        this.toastService.success(res.message);
      }).catch(({error}: {error:{ errors: { [key: string]: string }}}) => {
        this.isSpinnerActive = false;
        Object.values(error.errors).forEach(error => this.toastService.error());
      });
    }
  }
}
